// extracted by mini-css-extract-plugin
export default {"Logo":"Navbar_Logo__R3S2I","Link":"Navbar_Link__iybIx","WhiteBg":"Navbar_WhiteBg__vddCb"};